module.exports = __webpack_public_path__ + "img/eps_logo.dd324a7b.png";